import AppControlDriver from './app-control-driver';

let appControlDriverInstance = null;

const init = (params) => {
  if (appControlDriverInstance) throw new Error('AppControlDriver is already initialized');
  appControlDriverInstance = new AppControlDriver(params);
};

const get = () => appControlDriverInstance;

export default {
  init,
  get,
};
